import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';

import {exerciceOptions, youtubeOptions, fetchData} from '../utils/fetchData';
import Detail from '../components/Detail';
import ExerciceVideos from '../components/ExerciceVideos';
import SimilarExercices from '../components/SimilarExercices';

const ExerciceDetail = () => {
  const [exerciceDetail, setExerciceDetail] = useState({});
  const [exerciceVideos, setExerciceVideos] = useState([]);
  const [targetMuscleExercices, setTargetMuscleExercices] = useState([]);
  const [equipmentExercices, setEquipmentExercices] = useState([])
  const {id} = useParams();

  useEffect(() => {
    const fetchExercicesData = async ()=>{
      const exerciceDbUrl = 'https://exercisedb.p.rapidapi.com';
      const youtubeSearchUrl = 'https://youtube-search-and-download.p.rapidapi.com';

      const exerciceDetailData = await fetchData(`${exerciceDbUrl}/exercises/exercise/${id}`, exerciceOptions);
      setExerciceDetail(exerciceDetailData);

      const exerciceVideosData = await fetchData(`${youtubeSearchUrl}/search?query=${exerciceDetailData.name}`, youtubeOptions)
      setExerciceVideos(exerciceVideosData.contents);

      const targetMuscleExercicesData = await fetchData(`${exerciceDbUrl}/exercises/target/${exerciceDetailData.target}`, exerciceOptions);
      setTargetMuscleExercices(targetMuscleExercicesData);
      
      const equipmentExercicesData = await fetchData(`${exerciceDbUrl}/exercises/equipment/${exerciceDetailData.equipment}`, exerciceOptions); 
      setEquipmentExercices(equipmentExercicesData);

    }

    fetchExercicesData();

  }, [id])

  return (
    <Box>
      <Detail exerciceDetail = {exerciceDetail} />
      <ExerciceVideos exerciceVideos={exerciceVideos} name={exerciceDetail.name}/>
      <SimilarExercices targetMuscleExercices={targetMuscleExercices} equipmentExercices={equipmentExercices} />
    </Box>
  )
}

export default ExerciceDetail